import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {LinkCard} from 'shells/card/link-card';
import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {GridList} from 'shells/grid-list/grid-list';
import {getCrmLogoFromType} from 'shells/import2/helpers';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {useResizeObserver} from 'shells/utils/hooks/use-resize-observer';

import {CrmCard} from './crm-card';
import {useGetCrmListData} from './graphql/hooks/use-get-crms-list-data';

import styles from './import-from-crm-list.module.css';

export function ImportFromCRMList() {
    const [numColumns, setNumColumns] = React.useState<number>(2);
    const [chosenCrmLabel, setChosenCrmLabel] = React.useState<string>('');
    const containerRef = React.useRef<HTMLDivElement | null | undefined>(null);

    const {isLoading, crmOptions, onInitiateImport, initiateError} = useGetCrmListData();

    const setColumnsByWidth = (width?: number | null) => {
        if (width) {
            if (width < 600) {
                setNumColumns(1);
            } else if (width < 900) {
                setNumColumns(2);
            } else {
                setNumColumns(3);
            }
        }
    };

    // Set numColumns as soon as we have the ref
    React.useEffect(() => {
        if (containerRef.current) {
            setColumnsByWidth(containerRef.current.getBoundingClientRect().width);
        }
    }, [containerRef]);

    // Observe any resizing of the window and adjust numColumns accordingly
    const [width] = useResizeObserver(containerRef.current);
    React.useEffect(() => {
        if (typeof width === 'number') {
            setColumnsByWidth(width);
        }
    }, [width]);

    return (
        // @ts-expect-error
        <div ref={containerRef} className={styles.container}>
            {isLoading ? (
                <LoadingPage />
            ) : (
                <>
                    {initiateError && chosenCrmLabel && (
                        <FlashBanner type='error' isOverlay={true} duration={6000}>
                            Oops – something went wrong starting an import from {chosenCrmLabel} -
                            please try again and contact our support team if this error persists!
                        </FlashBanner>
                    )}
                    <GridList numColumns={numColumns}>
                        {crmOptions
                            ? crmOptions.map((crm) => (
                                  <CrmCard
                                      key={crm.type}
                                      label={crm.label}
                                      imgSrc={getCrmLogoFromType(crm.type)}
                                      onInitiateImport={() => {
                                          setChosenCrmLabel(crm.label);
                                          onInitiateImport(crm.type);
                                      }}
                                  />
                              ))
                            : undefined}
                        <LinkCard
                            // @ts-expect-error
                            as={RoutedLink}
                            preventUnderline={true}
                            key='other'
                            to='/setup/import/importer?type=other'
                        >
                            <div className={styles.content}>Other CRM</div>
                        </LinkCard>
                    </GridList>
                </>
            )}
        </div>
    );
}
